import { CartAddEvent } from '@theme/events';

let giftPending = false;

async function claimGift(button) {
  if (giftPending || button.disabled) return;
  const panel = button.closest('.ck-gift-choice');
  const select = panel?.querySelector('[data-cls-gift-size]');
  const status = panel?.querySelector('[data-cls-gift-status]');
  if (!select || !status) return;
  if (!select.value) {
    status.textContent = button.dataset.required;
    select.focus();
    return;
  }
  giftPending = true;
  const label = button.textContent;
  button.disabled = true;
  button.textContent = button.dataset.busy;
  button.classList.add('is-loading');
  status.textContent = '';
  let added = false;
  const claimId = String(Date.now()) + '-' + Math.random().toString(36).slice(2);
  const root = Theme.routes.cart_add_url.replace(/cart\/add(?:\.js)?$/, '');
  const readCart = async () => {
    const response = await fetch(root + 'cart.js', { cache: 'no-store' });
    if (!response.ok) throw new Error(button.dataset.error);
    return response.json();
  };
  const removeClaim = async () => {
    const cart = await readCart();
    const item = cart.items.find(item => item.properties?._cls_claim === claimId);
    if (!item) return;
    const response = await fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 }),
    });
    if (!response.ok) throw new Error(button.dataset.error);
  };
  try {
    const before = await readCart();
    if (before.items.some(item => item.properties?._cls_gift === 'classic-socks')) throw new Error(button.dataset.error);
    const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')]
      .map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: select.value, quantity: 1, properties: { _cls_gift: 'classic-socks', _cls_claim: claimId } }],
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || button.dataset.error);
    const after = await readCart();
    const gift = after.items.find(item => item.properties?._cls_claim === claimId);
    if (!gift || gift.final_line_price !== 0 || after.total_price > before.total_price) {
      await removeClaim();
      status.textContent = button.dataset.check;
      return;
    }
    added = true;
    document.dispatchEvent(new CartAddEvent(result, 'cls-gift-cta', {
      source: 'cls-gift-cta',
      sections: result.sections,
    }));
  } catch (error) {
    try { await removeClaim(); } catch { status.textContent = button.dataset.error; return; }
    status.textContent = error.message || button.dataset.error;
  } finally {
    giftPending = false;
    if (!added) {
      button.disabled = false;
      button.textContent = label;
      button.classList.remove('is-loading');
    }
  }
}

document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-cls-gift-claim]');
  if (!button) return;
  event.preventDefault();
  claimGift(button);
});


document.addEventListener('change', event => {
  if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-cls-gift-size]')) return;
  const status = event.target.closest('.ck-gift-choice')?.querySelector('[data-cls-gift-status]');
  if (status) status.textContent = '';
});

